import React, { Component } from 'react';
import ResultViePie from '../ResultViePie';
import { buildAnswerVariants, buildTitleOptions, buildChartData } from './../../utils/survey';

const colors = ['DeepSkyBlue', 'DeepPink', 'Indigo', 'BurlyWood', 'LightCoral', 'SaddleBrown', 'Goldenrod', 'Aqua', 'DarkGreen', 'IndianRed', 'Lime', 'Tomato'];

class ResultGender extends Component{
	render() {
		const { stepAnswers, answers } = this.props;
		const answerValues = Object.values(stepAnswers);
		const answerVariants = buildAnswerVariants(answerValues);
		const answerOptions = buildTitleOptions(answerVariants, answers);
		
		return <ResultViePie colors={colors} chartData={buildChartData(answerOptions)} {...this.props}/>;
	}
}

export default ResultGender;






// WEBPACK FOOTER //
// ./src/components/ResultGender/ResultGender.js